/**
 * Companies API service
 */
import axios from 'axios';
import {
  Company,
  CompanyCreate,
  CompanyUpdate,
  CompanyMember,
  CompanyMemberCreate,
  CompanyMemberUpdate,
  CompanyInvitation,
  CompanyInvitationCreate,
} from '../types/company';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// Company endpoints

export const listCompanies = async (): Promise<Company[]> => {
  const response = await axios.get(`${API_URL}/api/v1/companies`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });
  return response.data;
};

export const getCompany = async (id: number): Promise<Company> => {
  const response = await axios.get(`${API_URL}/api/v1/companies/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });
  return response.data;
};

export const createCompany = async (data: CompanyCreate): Promise<Company> => {
  const response = await axios.post(`${API_URL}/api/v1/companies`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });
  return response.data;
};

export const updateCompany = async (
  id: number,
  data: CompanyUpdate
): Promise<Company> => {
  const response = await axios.put(`${API_URL}/api/v1/companies/${id}`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });
  return response.data;
};

export const deleteCompany = async (id: number): Promise<void> => {
  await axios.delete(`${API_URL}/api/v1/companies/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });
};

// Company member endpoints

export const getCompanyMembers = async (companyId: number): Promise<CompanyMember[]> => {
  const response = await axios.get(`${API_URL}/api/v1/companies/${companyId}/members`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });
  return response.data;
};

export const addCompanyMember = async (
  companyId: number,
  data: CompanyMemberCreate
): Promise<CompanyMember> => {
  const response = await axios.post(
    `${API_URL}/api/v1/companies/${companyId}/members`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
  return response.data;
};

export const updateCompanyMemberRole = async (
  companyId: number,
  userId: number,
  data: CompanyMemberUpdate
): Promise<CompanyMember> => {
  const response = await axios.put(
    `${API_URL}/api/v1/companies/${companyId}/members/${userId}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
  return response.data;
};

export const removeCompanyMember = async (
  companyId: number,
  userId: number
): Promise<void> => {
  await axios.delete(`${API_URL}/api/v1/companies/${companyId}/members/${userId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });
};

// Company invitation endpoints

export const createInvitation = async (
  companyId: number,
  data: CompanyInvitationCreate
): Promise<CompanyInvitation> => {
  const response = await axios.post(
    `${API_URL}/api/v1/invitations/companies/${companyId}/invitations`,
    data,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
  return response.data;
};

export const listInvitations = async (companyId: number): Promise<CompanyInvitation[]> => {
  const response = await axios.get(
    `${API_URL}/api/v1/invitations/companies/${companyId}/invitations`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
  return response.data;
};

export const deleteInvitation = async (
  companyId: number,
  invitationId: number
): Promise<void> => {
  await axios.delete(
    `${API_URL}/api/v1/invitations/companies/${companyId}/invitations/${invitationId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
      },
    }
  );
};
